export default "__VITE_ASSET__JtnawmJ$__"